import { mapWithIndex } from 'fp-ts/Record';
/**
 *  @since 0.0.1
 */
export const Ctors = (tag) => (keys) => {
    const ctors = mapWithIndex((key, _) => (props) => (Object.assign(Object.assign({}, props), { [tag]: key })))(keys);
    return {
        of: ctors,
        as: ctors,
        make: (a) => a,
        tag
    };
};
